<!--  -->
<template>
  <div>
    <div class="search_box">
      <el-input v-model="pageIfonone.keyword" style="width:200px;margin-right:10px" placeholder="请输入appid/名称" />
      <el-select v-model="pageIfonone.mini_program_type" placeholder="请选择小程序类型">
        <el-option
          v-for="item in options"
          :key="item.mini_program_type"
          :label="item.type_name"
          :value="item.mini_program_type"
        />
      </el-select>
      <el-button type="primary" icon="el-icon-search" style="margin-left:10px" @click="search">搜索</el-button>
      <el-button type="info" icon="el-icon-refresh" @click="reast">重置</el-button>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="app_id"
        label="小程序appid"
        width="180"
        align="center"
      />
      <el-table-column
        prop="account_name"
        label="小程序名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="accountName"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="chooser(scope.row)">解绑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { /* programlist, */appletlistrw, mptypeslist } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      pageIfonone: {
        page: 1,
        page_size: 10,
        keyword: null,
        mini_program_type: null
      },
      tableData: [],
      total: null,
      options: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send() {
      this.getprogramlist()
      this.getapplettype()
    },
    async getapplettype() {
      const data = await mptypeslist()
      this.options = data.data.types
      console.log('data', data)
    },
    // 获取绑定列表
    async getprogramlist() {
      // const data = await programlist(this.pageIfonone)
      const data = await appletlistrw(this.pageIfonone)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfonone.pageSize = e
      this.getprogramlist()
    },
    fetchCurrentPage(e) {
      this.pageIfonone.page = e
      this.getprogramlist()
    },
    chooser(row) {
      console.log('row', row)
      this.$emit('unbandaccount', row.app_id)
    },
    search() {
      this.getprogramlist()
    },
    reast() {
      this.pageIfonone.page = 1
      this.pageIfonone.page_size = 10
      this.pageIfonone.keyword = null
      this.pageIfonone.mini_program_type = null
      this.getprogramlist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.search_box{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
</style>
